<template>
  <v-container>
    <v-row class="elevation-1">
      <v-col cols="6" lg="12">
        <v-btn
          id="create-new-fiscal-year"
          class="mx-2" color="primary"
          @click="openDialogbox"
        >
          Create New Fiscal Year
        </v-btn>
        <MtgCreateFiscalYear
          :dialog="dialog"
          @dialogVal="setDialog"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MtgCreateFiscalYear from '../../../components/Mtg/CreateFiscalYear/MtgCreateFiscalYear.vue';

export default {
  name: 'MortgageCreateFiscalYear',
  components: {
    MtgCreateFiscalYear,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {
  },
  methods: {
    openDialogbox() {
      this.dialog = true;
    },
    setDialog(val) {
      this.dialog = val;
    },
  },
};
</script>
